import { render } from "./NumberChart.vue?vue&type=template&id=60a6a620&scoped=true"
import script from "./NumberChart.vue?vue&type=script&lang=js"
export * from "./NumberChart.vue?vue&type=script&lang=js"

import "./NumberChart.vue?vue&type=style&index=0&id=60a6a620&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a6a620"]])

export default __exports__